import { ListSlice } from '../../prismicio-types'
import { asHTML } from '@prismicio/client'
import styles from './List.module.css'

export class List {
	static render(props: ListSlice) {
		const { items } = props

		return /* HTML */ `
			<div class="${styles.Main}">
				${items.map((item) => `<div class="${styles.Item}">${asHTML(item.text)}</div>`).join('')}
			</div>
		`
	}
}
